import { defineStore } from 'pinia'

export default defineStore('generic', {
  state: _ => ({
    visibleModal: null,
    visibleToastr: [],
    toastr: {
      login: {
        name: 'login',
        icon: 'check',
        content: 'Connexion réussie'
      },
      registration: {
        name: 'registration',
        icon: 'check',
        content: 'Votre compte a bien été créé'
      },
      orderCreated: {
        name: 'orderCreated',
        icon: 'check',
        content: 'Votre commande a été créé'
      },
      imagesSaved: {
        name: 'imagesSaved',
        icon: 'check',
        content: 'Image(s) enregistrée(s)'
      },
      franchiseError: {
        name: 'franchiseError',
        icon: 'exclamation-triangle',
        content: 'Erreur lors de l\'enregistrement de la franchise'
      },
      orderConfirmed: {
        name: 'orderConfirmed',
        icon: 'check',
        content: 'Le mail de confirmation de paiement a bien été renvoyé'
      }
    },

    /* Modals */
    modalNames: {
      cancellation: 'CANCELLATION',
      deleteDevice: 'DELETE_DEVICE',
      deleteDevices: 'DELETE_DEVICES',
      addPack: 'ADD_PACK',
      deletePack: 'DELETE_PACK',
      changeOffer: 'CHANGE_OFFER',
      emptyFields: 'EMPTY_FIELDS',
      payment: 'PAYMENT',
      signMandate: 'SIGN_MANDATE',
      docs: 'DOCUMENTS'
    }
  }),
  actions: {}
})
